export const reRegionConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_REGION_SUCCESS',
		REQUEST : 'GET_PAGED_REGION_REQUEST',
		FAILURE : 'GET_PAGED_REGION_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_REGION_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_REGION_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_REGION_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_REGION_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_REGION_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_REGION_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_REGION_REQUEST',
		SUCCESS : 'GET_LIST_REGION_SUCCESS',
		FAILURE : 'GET_LIST_REGION_FAILURE'
	},
	GetListForRoles: {
		REQUEST : 'GET_LIST_REGION_FOR_ROLES_REQUEST',
		SUCCESS : 'GET_LIST_REGION_FOR_ROLES_SUCCESS',
		FAILURE : 'GET_LIST_REGION_FOR_ROLES_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_REGION_REQUEST',
		SUCCESS : 'CREATE_REGION_SUCCESS',
		FAILURE : 'CREATE_REGION_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_REGION_REQUEST',
		SUCCESS : 'DELETE_REGION_SUCCESS',
		FAILURE : 'DELETE_REGION_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_REGION_REQUEST',
		SUCCESS : 'UPDATE_REGION_SUCCESS',
		FAILURE : 'UPDATE_REGION_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_REGION_REQUEST',
		SUCCESS : 'RESTORE_REGION_SUCCESS',
		FAILURE : 'RESTORE_REGION_FAILURE'
	},
	CLEAR: 'CLEAR_REGION'
}